module.exports = __webpack_public_path__ + "static/media/YF73_01.2e26271c.jpg";